module.exports = __webpack_public_path__ + "assets/0e2eacfa3128a39abebf1e9abec5aed1.mp3";